import { render } from "./TransactionTypes.vue?vue&type=template&id=23050921"
import script from "./TransactionTypes.vue?vue&type=script&lang=js"
export * from "./TransactionTypes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__